/**
 * 评分色标。从「红 → 金 → 浅绿 → 深绿」表达"差 → 好"的语义。
 *
 * 两套色标都用 hex 写死，目的是让 antd Tag 渲染成「实心彩底 + 白字」效果
 * （传 preset 字符串如 'red' / 'gold' 会渲染浅色描边款，对比度弱）。
 *
 *  - ANCHOR_COLORS：胜任力 1-5 分（5 档锚定）
 *  - LEVEL_COLOR：360 素质 7 分制 4 档（待发展/胜任/优秀/卓越），与胜任力色系对齐
 *      待发展 = 1 分红、胜任 = 3 分金、优秀 = 4 分浅绿、卓越 = 5 分深绿
 *
 * 集中在此文件维护，避免每个页面各自一份导致漂移。
 */

export const ANCHOR_COLORS: Record<string, string> = {
  '1': '#ff4d4f', // red-5
  '2': '#fa8c16', // orange-5
  '3': '#faad14', // gold-5
  '4': '#73d13d', // green-4
  '5': '#389e0d', // green-7
};

export const LEVEL_COLOR: Record<string, string> = {
  待发展: '#ff4d4f',
  胜任: '#faad14',
  优秀: '#73d13d',
  卓越: '#389e0d',
};
